import { useState } from "react";
import { SmallTalkAI } from "../../lib/smalltalkApi";

function getLang() {
  return (typeof document !== "undefined" && document.documentElement?.lang) || "ko";
}

export default function SmallTalkPage() {
  const lang = getLang();

  const [record, setRecord] = useState("");
  const [busy, setBusy] = useState(false);
  const [resultHtml, setResultHtml] = useState("");

  function emptyMessage() {
    return lang === "zh-CN"
      ? '<p class="text-red-500 text-center">请先输入患者记录。</p>'
      : '<p class="text-red-500 text-center">환자 기록을 먼저 입력해주세요.</p>';
  }

  function sysErrorHtml() {
    return lang === "zh-CN"
      ? '<p class="text-red-500 text-center">抱歉。发生了错误。请稍后再试。</p>'
      : '<p class="text-red-500 text-center">죄송합니다. 오류가 발생했습니다. 잠시 후 다시 시도해주세요.</p>';
  }

  async function handleGenerate() {
    const value = record.trim();
    if (!value) {
      setResultHtml(wrapReport(emptyMessage()));
      return;
    }

    setBusy(true);
    setResultHtml(""); // clear

    try {
      const { text } = await SmallTalkAI.generate({ record: value });
      const raw = String(text || "");

      // ✅ 불릿/번호형 목록까지 잡기: -, •, *, 1.
      const lines = raw.split("\n").map((l) => l.trim()).filter(Boolean);

      const topicLines = lines.filter((l) => /^[-•*]\s+/.test(l) || /^\d+\.\s+/.test(l));

      if (topicLines.length > 0) {
        const listHtml = topicLines
          .map((line) => {
            const onlyText = line.replace(/^([-•*]|\d+\.)\s+/, "").trim();
            return `
              <div class="report-markdown">
                <span>${escapeHtml(onlyText)}</span>
              </div>
            `;
          })
          .join("");

        setResultHtml(wrapReport(listHtml));
      } else {
        // ✅ 목록이 아니어도 래퍼는 항상 유지
        setResultHtml(wrapReport(`<p>${escapeHtml(raw).replace(/\n/g, "<br>")}</p>`));
      }
    } catch (e) {
      console.error(e);
      setResultHtml(wrapReport(sysErrorHtml()));
    } finally {
      setBusy(false);
    }
  }

  // ✅ 래퍼를 "항상" 씌우기
  function wrapReport(innerHtml) {
    return `<div class="report-body"><div class="report-body-area">${innerHtml}</div></div>`;
  }

  // 간단한 HTML escape (결과 안전 표시용)
  function escapeHtml(s) {
    return String(s)
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#39;");
  }

  return (
    <section className="smallTalk">
      <div id="content_title">
        <h2>스몰토크 토픽 생성기</h2>
        <p>환자분의 마지막 진료 기록을 입력하고, 따뜻한 대화 주제를 찾아보세요!</p>
      </div>

      <div className="content">
        {/* 입력 섹션 */}
        <div>
          <p>환자 진료기록</p>
          <textarea
            rows={4}
            className="textarea"
            placeholder="예: 체중 1.5kg 감량 성공, 식단 잘 지키고 계심. 다음 주 제주도 여행 계획 있으심."
            value={record}
            onChange={(e) => setRecord(e.target.value)}
          />
        </div>

        {/* 생성 버튼 */}
        <div style={{ alignItems: "center" }}>
          <button id="generate-button" className="submitbtn" onClick={handleGenerate}>
            대화 주제 생성하기
          </button>
        </div>

        {/* 결과 섹션 */}
        <div>
          <div id="result-container">
            {busy ? "스몰토크 생성중" : <div className="report" dangerouslySetInnerHTML={{ __html: resultHtml }} />}
          </div>
        </div>
      </div>
    </section>
  );
}
